import { isHandledErrorKey } from 'src/dataLayer/remoteData/babbelAPI/shared/handledErrorKeys'
import { reportUncaughtException, reportUnhandledRejection } from 'src/dataLayer/remoteData/rollbar'

// eslint-disable-next-line unicorn/prefer-add-event-listener -- we need to use onerror for legacy compatibility
globalThis.onerror = (message, url, lineNumber, columnNumber, error) => {
  reportUncaughtException(message, url, lineNumber, columnNumber, error)
  // returning false keeps the default browser error logging in place
  return false
}

globalThis.onunhandledrejection = (event) => {
  if (!isHandledErrorKey(event.reason)) {
    reportUnhandledRejection(event.reason)
  }
}
